<template>
  <div class="static-cards">
    <div v-if="icon" class="cards-icon">
      <i :class="`fo ${ icon } fo-detail`" />

      <div
        v-if="!hideFavorite"
        :class="['cards-action cards-favorite', { 'active': isFavorite }]"
        @click="$emit('favorite')"
      >
        <i class="fo">
          <span class="hint">{{ isFavorite ? 'Entfernen' : 'Hinzufügen' }}</span>
        </i>
      </div>
    </div>

    <div v-else-if="image" class="cards-image">
      <img :src="image">
    </div>

    <div class="cards-text">
      <h3 :class="icon && 'h3-min-height'">{{ name }}</h3>
      <p v-html="html" />
    </div>

    <div class="cards-bottom">
      <a
        v-if="linkMore"
        :href="linkMore"
        class="large arrow"
        target="_blank"
      >
        <span class="d-inlint-block mb-1">Mehr Informationen</span>
      </a>

      <a
        v-if="linkOffer"
        :href="linkOffer"
        class="button block mt-3"
        target="_blank"
        @click="$emit('click-offer')"
      >
        <i :class="`fo fo-paper`"/>
        <span>Angebot anfordern</span>
      </a>

      <a
        v-if="linkCalc"
        :href="linkCalc"
        class="button call-to-action block mt-3"
        target="_blank"
        @click="$emit('click-calc')"
      >
        <i :class="`fo fo-calculator`"/>
        <span>Beitrag berechnen</span>
      </a>

      <a
        v-if="linkCompare"
        :href="linkCompare"
        class="button call-to-action block mt-3"
        target="_blank"
        @click="$emit('click-tarife')"
      >
        <i :class="`fo fo-calculator`"/>
        <span>Tarife vergleichen</span>
      </a>

      <p v-if="canComplete" class="small text-center">
        <i class="fo fo-check" /> Auf Wunsch online abschließen
      </p>

      <a
        v-if="linkWatch"
        :href="linkWatch"
        class="button call-to-action button block mt-3"
        target="_blank"
      >
        <i :class="`fo fo-chat`"/>
        <span>Live-Beratung starten</span>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'insurance-card',

  props: {
    name: {
      type: String,
      default: ''
    },

    icon: {
      type: String,
      default: ''
    },

    image: {
      type: String,
      default: ''
    },

    html: {
      type: String,
      default: ''
    },

    linkMore: {
      type: String,
      default: ''
    },

    linkOffer: {
      type: String,
      default: ''
    },

    linkCalc: {
      type: String,
      default: ''
    },

    linkCompare: {
      type: String,
      default: ''
    },

    linkWatch: {
      type: String,
      default: ''
    },

    canComplete: {
      type: Boolean,
      default: false
    },

    isFavorite: {
      type: Boolean,
      default: false
    },

    hideFavorite: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    iconForCalc () {
      if (!this.labelExternal) {
        return 'fo-calculator';
      }

      return this.labelExternal.toLowerCase().indexOf('angebot') >= 0
        ? 'fo-paper'
        : 'fo-calculator';
    }
  },
};
</script>

<style lang="scss" scoped>
.cards-text {
  word-wrap: break-word !important;
}

.cards-favorite {
  line-height: 100% !important;
}

.cards-image {
  width: 100%;

  img {
    width: 100%;
  }
}

.static-cards {
  padding-bottom: 0px;
  .cards-bottom {
    position: relative;
    height: auto;
    .topspace {
      margin-top: 30px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/insurance-card.vue